import { getChartValueShare } from '../../../Chart'
import { BIRDVIEW_META_SEPARATOR } from '../../DashboardBirdview.constants'
import { formatBirdviewKpiValue } from '../../DashboardBirdview.utils.charts'

import { BIRDVIEW_CHART_STACKED_SEGMENTS } from './BirdviewBarsChartRow.constants'

export function checkIsBirdviewBarsChartRowStacked({ isStacked, item }) {
  return isStacked && !item.isMuted
}

export function getBirdviewBarsChartRowSegments(item) {
  return BIRDVIEW_CHART_STACKED_SEGMENTS.filter(({ key }) => item[key] > 0)
}

export function getBirdviewBarsChartSegmentStyle({ color, maxValue, value }) {
  return {
    '--birdview-segment-color': color,
    width: `${getChartValueShare(value, maxValue)}%`,
  }
}

export function getBirdviewBarsChartRowTooltipRows({
  isStacked,
  item,
  t,
  total,
  valueUnit,
  withShare,
}) {
  if (isStacked) {
    return BIRDVIEW_CHART_STACKED_SEGMENTS.map(({ color, key, labelKey }) => ({
      color,
      id: key,
      label: t(labelKey),
      value: item[key],
    }))
  }

  return [
    {
      id: item.id,
      value: withShare
        ? `${item.value}${BIRDVIEW_META_SEPARATOR}${getChartValueShare(item.value, total)}%`
        : formatBirdviewKpiValue({ t, unit: valueUnit, value: item.value }),
    },
  ]
}
